module.exports = __webpack_public_path__ + "static/media/blueArrow.ed1f03fe.svg";